import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { cart_actions, wishlist_actions } from "../../redux-store";
import ProductItem from "../layouts/common/product-item";
import backend from "../../api";
import ClipLoader from "react-spinners/ClipLoader";

const RelatedProduct = ({ product }) => {
  const dispatch = useDispatch();
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const symbol = useSelector((state) => state.data.symbol);
  const user = useSelector((state) => state.auth.user);
  const getRelatedProducts = async (product) => {
    setIsLoading(true);
    try {
      const { data } = await backend.get("/product", {
        params: {
          limit: 6,
          product_category: product?.product_category?._id,
        },
      });
      const relatedProducts = data?.data.filter(
        (el) => el?._id !== product?._id
      );
      setProducts(relatedProducts);
    } catch (error) {
      console.error("error: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  const add_to_cart = (unit) => {
    dispatch(cart_actions.add_to_cart(unit));
  };

  const add_to_wishlist = (unit) => {
    dispatch(wishlist_actions.add_to_wishlist(unit));
  };

  useEffect(() => {
    getRelatedProducts(product);
  }, [product]);

  return (
    <section className="section-b-space related-product">
      <div className="container">
        <div className="row">
          <div className="col-12 product-related">
            <h2>related products</h2>
          </div>
        </div>
        <div className="row search-product">
          {isLoading ? (
            <div className="col-12">
              <div className=" d-flex justify-content-center">
                <ClipLoader color={"#000000"} loading={isLoading} size={40} />
              </div>
            </div>
          ) : products?.length > 0 ? (
            products.map((product, index) => (
              <div key={index} className="col-xl-2 col-md-4 col-sm-6">
                <ProductItem
                  product={product}
                  symbol={symbol}
                  onAddToWishlistClicked={add_to_wishlist}
                  onAddToCartClicked={add_to_cart}
                  user={user}
                />
              </div>
            ))
          ) : (
            <div className="col-12 text-center">
              <span className="alert">No Related Products Found</span>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default RelatedProduct;
